import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { IconButton } from '../../../../../../BaseComponents';
import { WithTooltip } from '@shared/ui/WithTooltip';
const UploadedFile = ({ className, name, error, onClick, onDelete }) => {
    const { UploadedFile: css } = useTheme('Shared').FileUpload;
    return (React.createElement("div", { className: cn(css.root, className, { [css.pointer]: !!onClick, [css.error]: !!error }) },
        React.createElement(WithTooltip, { title: error },
            React.createElement("div", { className: css.leftBlock, onClick: onClick },
                React.createElement(CdnIcon, { className: css.iconFile, icon: !!error ? 'Info/Not included' : 'Document/File' }),
                React.createElement("span", { className: css.name }, name))),
        !!onDelete && (React.createElement(IconButton, { classes: {
                root: css.iconButton
            }, onClick: onDelete },
            React.createElement(CdnIcon, { icon: "Action/Remove", className: css.removeIcon })))));
};
export default UploadedFile;
